// Mock data for Camel Rubber Bush website

export const productSpecs = [
  { label: "Material", value: "Premium Grade Rubber" },
  { label: "Temperature Resistance", value: "-20°C to 120°C" },
  { label: "Pressure Rating", value: "Up to 150 PSI" },
  { label: "Size Range", value: "1\" to 12\" diameter" },
  { label: "Hardness", value: "Shore A 60-80" },
  { label: "Lifespan", value: "5+ years under normal conditions" },
  { label: "Certifications", value: "ISO 9001:2015 Certified" },
  { label: "Application", value: "Submersible Pumps & Motors" }
];

export const benefits = [
  {
    title: "Sand Resistant",
    description: "Specially designed to withstand sand and debris that comes with water, ensuring uninterrupted pump performance.",
    icon: "Shield"
  },
  {
    title: "Heat Tolerant",
    description: "Works efficiently even in high-temperature conditions without melting or degrading.",
    icon: "Flame"
  },
  {
    title: "Long Lasting",
    description: "Premium rubber compound ensures extended lifespan and minimal maintenance requirements.",
    icon: "Clock"
  },
  {
    title: "Water Resistant",
    description: "Complete water sealing prevents moisture damage to pump motors and internal components.",
    icon: "Droplet"
  },
  {
    title: "Cost Effective",
    description: "Reduces pump maintenance costs and extends equipment life, providing excellent ROI.",
    icon: "IndianRupee"
  },
  {
    title: "Easy Installation",
    description: "Simple to install and replace, minimizing downtime and labor costs.",
    icon: "Wrench"
  }
];

export const testimonials = [
  {
    name: "Rajesh Kumar",
    company: "Gujarat Irrigation Ltd.",
    location: "Ahmedabad, Gujarat",
    rating: 5,
    text: "We've been using Camel Rubber Bush for 3 years now. The quality is outstanding and our pump maintenance costs have reduced by 40%."
  },
  {
    name: "Suresh Patel",
    company: "Patel Agro Industries",
    location: "Mehsana, Gujarat",
    rating: 5,
    text: "Excellent product! Even in sandy water conditions, the rubber bush performs flawlessly. Highly recommended for all submersible pumps."
  },
  {
    name: "Amit Desai",
    company: "Desai Water Solutions",
    location: "Gandhinagar, Gujarat",
    rating: 5,
    text: "Best quality rubber bush in the market. The heat resistance is impressive. Our clients are very satisfied with the performance."
  }
];

export const priceList = [
  { size: "1 inch", price: "150", unit: "piece" },
  { size: "2 inch", price: "280", unit: "piece" },
  { size: "3 inch", price: "420", unit: "piece" },
  { size: "4 inch", price: "580", unit: "piece" },
  { size: "5 inch", price: "750", unit: "piece" },
  { size: "6 inch", price: "920", unit: "piece" }
];

export const contactInfo = {
  phone: "+91 9824138001",
  whatsapp: "+91 9824138001",
  email: "camel.rubberindustries@gmail.com",
  address: "14, Dhara Estate, Santej-Khatraj Road, Santej, Ta.: Kalol, Gandhinagar, Ahmedabad, Gujarat, India"
};

// Store form submissions in browser localStorage
export const saveQuoteRequest = (data) => {
  const existing = JSON.parse(localStorage.getItem('quoteRequests') || '[]');
  existing.push({ ...data, id: Date.now(), date: new Date().toISOString() });
  localStorage.setItem('quoteRequests', JSON.stringify(existing));
};

export const saveContactMessage = (data) => {
  const existing = JSON.parse(localStorage.getItem('contactMessages') || '[]');
  existing.push({ ...data, id: Date.now(), date: new Date().toISOString() });
  localStorage.setItem('contactMessages', JSON.stringify(existing));
};
